export enum Step {
    EnterEmail,
    EnterCode,
    ChangePassword,
    Login,
    Logout,
}